import BadgeColumn, { cellType, badgeColumnConfiguration } from './BadgeColumn.component';

export { cellType, BadgeColumn };
export default badgeColumnConfiguration;
